import { createParser, system } from "@styled-system/core";
var config = {
  boxShadow: {
    property: "boxShadow",
    scale: "shadows"
  },
  textShadow: {
    property: "textShadow",
    scale: "shadows"
  },
  shadow: {
    property: "boxShadow",
    scale: "shadows"
  }
};
/**
 * Types for box and text shadow properties
 */

export var shadow = system(config);
export var shadowParser = createParser(config);
//# sourceMappingURL=shadow.js.map